export const campaignContributionTypeSelect = [
    {
        value: 'Fixed',
        display: 'Fixed'
    },
    {
        value: 'Percentage',
        display: 'Percentage'
    }
]